import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLetterZCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLetterZCircle"><Path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8.72461 7.77246V9.50098H12.627V9.6123L8.66016 14.8623V16.2275H15.3281V14.499H11.2383V14.3877L15.2051 9.1377V7.77246H8.72461Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterZCircle;
